import { TApplicationState } from '../../types/redux';

export const selectFormRequiresAuth = (state: TApplicationState) => state.requestFormV2.meta.requiresAuth;
